import get from 'lodash/get'
import { IMetro } from 'interfaces/metro'
import { getValidArray } from 'utils/common'

export function sortMetroByOrder(metroList: IMetro[]): IMetro[] {
  return getValidArray([...metroList]).sort((currentMetro: IMetro, nextMetro: IMetro) => {
    return get(currentMetro, 'order', 0) - get(nextMetro, 'order', 0)
  })
}
